import { CHATBOT_COMMANDS } from '~/utils/chat-flags';
import { getElectricityPrepaidTransaction } from '~/api/electricity-prepaid';
import { getInvoices } from '~/api/invoices';

export default {
  methods: {
    /**
     * Check user's electricity prepaid transaction status
     * @command - [apicall] checkElectricityPrepaidTrxStatus [/apicall]
     * @param {object} currentTrx - currently selected transaction object
     */
    async checkElectricityPrepaidTrxStatus(currentTrx = null) {
      if (!currentTrx) {
        this.$zopim.sendChatMsg(CHATBOT_COMMANDS.responses.noSelectedTransaction);
        return;
      }

      const responses = {
        electricityPrepaidTrxStatus: '[apiresponse] electricityPrepaidTrxStatus<state> [/apiresponse]',
        checkElectricityPrepaidTrxStatusError: '[apiresponse] checkElectricityPrepaidTrxStatusError [/apiresponse]',
      };

      try {
        // Get invoice data
        const {
          data: [invoiceData],
        } = await getInvoices(this.$axios, { keywords: currentTrx.paymentId });
        const {
          transactions: [invoiceTrx],
        } = invoiceData;

        const { data: electricityPrepaidData } = await getElectricityPrepaidTransaction(this.$axios, {
          transactionId: invoiceTrx.id,
        });
        const { state } = electricityPrepaidData;
        const capitalizedState = state.charAt(0).toUpperCase() + state.slice(1);
        const finalResponse = responses.electricityPrepaidTrxStatus.replace('<state>', capitalizedState);
        this.$zopim.sendChatMsg(finalResponse);
      } catch (error) {
        this.$zopim.sendChatMsg(responses.checkElectricityPrepaidTrxStatusError);
        console.error(
          '[ERROR] Something is wrong when trying to check user electricity prepaid transaction state',
          error
        );
      }
    },
  },
};
